<template>
    <div>
        <Header />
        <section class="section-b-space">
            <div>
                <div>
                    <div v-if="userRole === 'Partner'">
                        <h3>My Profile</h3>
                        <b-card>
                            <b-row>
                                <b-col md="4">
                                    <div style="text-align: center">
                                        <div class="tenantProfile_img">
                                            <single-image
                                                class="profile-img"
                                                height="147px"
                                                width="147px"
                                                @change="
                                                    (d) =>
                                                        uploadImage(
                                                            'profilePhoto',
                                                            d
                                                        )
                                                "
                                                :id="'profilePhoto'"
                                                ref="profilePhoto"
                                                :url="userLogo"
                                                label="Browse Profile Photo"
                                            ></single-image>
                                            <span
                                                v-if="unsuppprtedFile"
                                                class="validate-error"
                                                >Unsupported file format! Please
                                                select an image</span
                                            >
                                        </div>
                                        <div class="mt-4">
                                            <p>
                                                <b>Username :</b>
                                                {{
                                                    (userInfo &&
                                                        userInfo.authentication &&
                                                        userInfo.authentication
                                                            .userName) ||
                                                    ""
                                                }}
                                            </p>
                                            <div class="text-center mt-2">
                                                <v-btn
                                                    small
                                                    style="
                                                        background-color: var(
                                                            --primary
                                                        );
                                                    "
                                                    @click="
                                                        $router.push({
                                                            path: '/myaccount/viewprofile/edit-profile',
                                                        })
                                                    "
                                                    color="primary"
                                                    >Edit Profile</v-btn
                                                >
                                                <v-btn
                                                    small
                                                    style="
                                                        background-color: var(
                                                            --primary
                                                        );
                                                    "
                                                    color="primary"
                                                    @click="
                                                        $router.push({
                                                            path: '/myaccount/changepassword',
                                                        })
                                                    "
                                                >
                                                    Change Password
                                                </v-btn>
                                            </div>
                                        </div>
                                    </div>
                                </b-col>
                                <b-col md="8">
                                    <h4 class="text-primary">
                                        Personal Information
                                    </h4>
                                    <b-row>
                                        <b-col md="6">
                                            <p>
                                                <b> E-mail : </b>
                                                {{
                                                    (userInfo &&
                                                        userInfo.authentication &&
                                                        userInfo.authentication
                                                            .email) ||
                                                    ""
                                                }}
                                            </p>
                                        </b-col>
                                        <b-col md="6">
                                            <div>
                                                <p>
                                                    <b>Phone : </b>
                                                    {{
                                                        (userInfo &&
                                                            userInfo.authentication &&
                                                            userInfo
                                                                .authentication
                                                                .phone) ||
                                                        ""
                                                    }}
                                                </p>
                                            </div>
                                        </b-col>
                                    </b-row>
                                    <b-row
                                        v-if="userInfo && userInfo.status"
                                        class="p-0 m-0"
                                    >
                                        <b-col md="6" class="p-0 m-0">
                                            <p>
                                                Account Status :
                                                {{ userInfo.status }}
                                            </p>
                                        </b-col>
                                    </b-row>
                                    <h4 class="text-primary">
                                        Address Information
                                    </h4>
                                    <b-row>
                                        <b-col md="6">
                                            <p>
                                                <b>Country : </b>
                                                {{
                                                    (userInfo &&
                                                        userInfo.office &&
                                                        userInfo.office
                                                            .address &&
                                                        userInfo.office.address
                                                            .country) ||
                                                    ""
                                                }}
                                            </p>
                                            <p>
                                                <b>Street 1 : </b>
                                                {{
                                                    (userInfo &&
                                                        userInfo.office &&
                                                        userInfo.office
                                                            .address &&
                                                        userInfo.office.address
                                                            .street1) ||
                                                    ""
                                                }}
                                            </p>
                                            <p>
                                                <b>House No : </b>
                                                {{
                                                    (userInfo &&
                                                        userInfo.office &&
                                                        userInfo.office
                                                            .address &&
                                                        userInfo.office.address
                                                            .houseNumber) ||
                                                    ""
                                                }}
                                            </p>
                                        </b-col>
                                        <b-col md="6">
                                            <p>
                                                <b>State : </b>
                                                {{
                                                    (userInfo &&
                                                        userInfo.office &&
                                                        userInfo.office
                                                            .address &&
                                                        userInfo.office.address
                                                            .state) ||
                                                    ""
                                                }}
                                            </p>
                                            <p
                                                v-if="
                                                    userInfo &&
                                                    userInfo.office &&
                                                    userInfo.office.address &&
                                                    userInfo.office.address
                                                        .street2
                                                "
                                            >
                                                <b>Street 2 : </b>
                                                {{
                                                    userInfo.office.address
                                                        .street2
                                                }}
                                            </p>
                                            <p>
                                                <b>Zip : </b>
                                                {{
                                                    (userInfo &&
                                                        userInfo.office &&
                                                        userInfo.office
                                                            .address &&
                                                        userInfo.office.address
                                                            .zip) ||
                                                    ""
                                                }}
                                            </p>
                                        </b-col>
                                    </b-row>
                                    <h4 class="text-primary">
                                        Additional Information
                                    </h4>
                                    <b-row
                                        ><div
                                            v-if="
                                                Object.keys(extendedData)
                                                    .length == 0
                                            "
                                        >
                                            No Data Available
                                        </div>
                                        <b-col
                                            md="6"
                                            v-for="(
                                                [key, value], index
                                            ) in Object.entries(extendedData)"
                                            :key="index"
                                            class="line-bottom"
                                        >
                                            <b-row
                                                :class="{
                                                    line: index % 2 == 1,
                                                }"
                                            >
                                                <b-col>
                                                    <p class="left-text">
                                                        <b>
                                                            {{
                                                                camelCaseToTitleCase(
                                                                    key
                                                                )
                                                            }}
                                                            :</b
                                                        >

                                                        {{
                                                            formatString(value)
                                                        }}
                                                    </p>
                                                </b-col> </b-row
                                            ><b-col class="line"> </b-col>
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </b-row>
                        </b-card>
                    </div>
                    <div class="row">
                        <b-tabs v-if="userRole === 'Tenant'">
                            <b-tab title="Tenant Preference">
                                <b-card
                                    style="width: 1050px"
                                    border-variant="info"
                                    header-bg-variant="primary"
                                    header-text-variant="white"
                                    class="card-wrap"
                                    header="Update Tenant Preference"
                                >
                                    <div>
                                        <div>
                                            <b-row>
                                                <b-col>
                                                    <v-select
                                                        v-model="
                                                            selectedLanguage
                                                        "
                                                        :items="languages"
                                                        item-text="name"
                                                        item-value="id"
                                                        return-object
                                                        label="Select Language"
                                                        chips
                                                        multiple
                                                        hint="What are the target language"
                                                    ></v-select>
                                                </b-col>
                                            </b-row>
                                            <b-row>
                                                <b-col>
                                                    <v-select
                                                        :items="
                                                            selectedLanguage
                                                        "
                                                        item-text="name"
                                                        item-value="id"
                                                        v-model="
                                                            defaultLanguage
                                                        "
                                                        label="Default Language"
                                                        chips
                                                    ></v-select>
                                                </b-col>
                                            </b-row>
                                            <b-row class="mt-1">
                                                <b-col md="3">
                                                    <v-checkbox
                                                        v-model="lightMode"
                                                        label="Enable lightMode "
                                                    ></v-checkbox>
                                                </b-col>
                                                <b-col md="4">
                                                    <v-checkbox
                                                        v-model="
                                                            enableManufacturer
                                                        "
                                                        label="Enable Manufacturer "
                                                    ></v-checkbox>
                                                </b-col>
                                            </b-row>
                                        </div>
                                        <button
                                            @click.prevent="onSaveLanguage"
                                            type="button"
                                            class="btn btn-solid btn-primary"
                                        >
                                            Save
                                        </button>
                                    </div>
                                </b-card>
                            </b-tab>
                        </b-tabs>
                    </div>
                </div>
            </div>
        </section>
        <Footer class="mt-5" />
    </div>
</template>
<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapGetters, mapActions, mapState } from "vuex";
import SingleImage from "../../components/Common/Image.vue";
import Vue from "vue";
import Organization from "@/components/Partner/PartnerView/Organization.vue";
import moment from "moment";

export default {
    components: {
        ValidationProvider,
        ValidationObserver,
        SingleImage,
    },
    data() {
        return {
            unsuppprtedFile: false,
            langObj: {
                en: "English",
                bn: "Bengali",
                te: "Telugu",
            },
            lightMode: true,
            enableManufacturer: false,
            paramsId: null,
            isEditMode: false,
            oldPwd: "",
            newPwd: "",
            cfmPwd: "",
            errorMessages: "",
            details: {
                name: "",
                phone: "",
                email: "",
            },
            hasAddress: false,
            address: {
                city: "",
                country: "",
                houseNumber: "",
                state: "",
                street1: "",
                zip: "",
                location: {
                    coordinates: [0, 0],
                },
            },
            selectedLanguage: [],
            defaultLanguage: "",
            languages: [
                { id: "en", name: "English" },
                { id: "bn", name: "Bengali" },
                { id: "te", name: "Telugu" },
            ],
        };
    },
    computed: {
        ...mapGetters({
            userInfo: "profileUpdate/GetmeTenant",
            tenantLanguage: "tenant/GetTenantLanguage",
            tenantPreferences: "tenant/GetTenantPreferences",
        }),
        ...mapState({
            extendedData: (state) => state.profileUpdate.extendedData,
        }),
        userLogo() {
            return (
                JSON.parse(sessionStorage.userLogin)?.userLogo ||
                "img/avatars/6.jpg"
            );
        },
        userRole() {
            return (
                this.$store.getters["auth/getUserRole"] ||
                JSON.parse(sessionStorage.getItem("userLogin"))?.role
            );
        },
        userId() {
            return (
                this.$store.getters["auth/getUserID"] ||
                JSON.parse(sessionStorage.getItem("userLogin"))?._id
            );
        },
    },
    mounted() {
        if (this.userRole === "Tenant") {
            this.getPreference(this.userId).then((result) => {
                if (result.status === 1) {
                    if (
                        this.tenantPreferences.languages &&
                        this.tenantPreferences.languages.length > 0
                    ) {
                        this.tenantPreferences.languages.forEach((obj) => {
                            this.selectedLanguage.push({
                                id: obj,
                                name: this.langObj[obj],
                            });
                        });
                        this.defaultLanguage =
                            this.tenantPreferences.defaultLanguage;
                        this.lightMode = this.tenantPreferences.lightMode;
                        this.enableManufacturer =
                            this.tenantPreferences.enableManufacturer;
                    }
                }
            });
        }
        this.$store.dispatch("profileUpdate/fetchmeTenant");
    },
    methods: {
        ...mapActions({
            updateProfile: "profileUpdate/updateTenant",
            changePassword: "profileUpdate/UpdatePassword",
            updatePreference: "tenant/updateTenantPreferences",
            getPreference: "tenant/getTenantPreferences",
        }),
        formatString(dateString) {
            const datePattern = /\d{1,2}[/-]\d{1,2}[/-]\d{2,4}/; // Adjust the regex based on expected date formats
            if (
                typeof dateString === "string" &&
                datePattern.test(dateString)
            ) {
                const date = moment(dateString);

                if (date.isValid()) {
                    // Render the date in a desired format, e.g., 'MMMM Do YYYY'
                    return date.format("MMMM Do YYYY");
                }
            }
            return dateString; // Return original if not a valid date string
        },

        camelCaseToTitleCase(camelCaseString) {
            const titleCaseString = camelCaseString
                .replace(/([A-Z])/g, " $1") // Add space before uppercase letters
                .replace(/_/g, " "); // Replace underscores with spaces

            return titleCaseString
                .split(" ")
                .map(
                    (word) =>
                        word.charAt(0).toUpperCase() +
                        word.slice(1).toLowerCase()
                )
                .join(" ");
        },
        async uploadImage(path, image) {
            if (!image.includes("data:image")) {
                this.userinfo[path] = null;
                this.unsuppprtedFile = true;

                return;
            }
            this.unsuppprtedFile = false;

            let dataobj = {
                image: image,
                key: (
                    Date.now().toString(36) +
                    Math.random().toString(36).substr(2, 5)
                ).toLowerCase(),
                isPublic: true,
                replaceExisting: true,
                basePath: ["agent", "profilePhoto"],
            };
            this.showCustomToast();
            await this.$store
                .dispatch("inventory/uploadImageToStorage", dataobj)
                .then((res) => {
                    this.clearCustomToast();
                    const userLogo = res.data.fileUrl;
                    const payload = {
                        id: this.userId,
                        data: {
                            organization: {
                                logo: userLogo,
                            },
                        },
                    };
                    this.$store
                        .dispatch("partner/updateprofileAction", payload)
                        .then(() => {
                            this.userLogo = userLogo;
                            let userLogin = JSON.parse(
                                sessionStorage.getItem("userLogin")
                            );
                            userLogin.userLogo = userLogo;
                            sessionStorage.setItem(
                                "userLogin",
                                JSON.stringify(userLogin)
                            );
                            window.location.reload();
                        });
                })
                .catch((error) => {
                    this.clearCustomToast();
                    this.$toasted.error(
                        "Image not uploaded..please try again!"
                    );
                });
        },
        showCustomToast() {
            Vue.toasted.show("Uploading...", {
                type: "info",
                theme: "toasted-primary",
                singleton: true,
                duration: 1000000,
            });
        },
        clearCustomToast() {
            Vue.toasted.clear();
        },
        onSaveLanguage() {
            let languages = [];
            if (this.selectedLanguage && this.selectedLanguage.length > 0) {
                this.selectedLanguage.forEach((obj) => {
                    languages.push(obj.id);
                });
            }
            let payload = {
                id: this.userId,
                data: {
                    languages: languages,
                    defaultLanguage: this.defaultLanguage
                        ? this.defaultLanguage
                        : "en",
                    lightMode: this.lightMode,
                    enableManufacturer: this.enableManufacturer,
                },
            };
            this.updatePreference(payload).then((result) => {
                this.$toasted.success("Tenant preferences updated.");
                if (result.status === 1) {
                    this.getPreference(this.userId);
                }
            });
        },
    },
};
</script>
<style scoped>
.Account-card {
    background-color: #ffffff;
    padding-top: 18px;
}
/* p {
  font-size: 13px;
} */
.v-btn {
    text-transform: capitalize;
}
.center {
    margin-left: auto;
    margin-right: auto;
}
table {
    border-collapse: collapse;
    border-spacing: 0;
    width: 100%;
}

th,
td {
    padding: 8px;
}
th {
    width: 20%;
}
.profile-img {
    margin-top: -14px;
    margin-left: -75px;
}
.tenantProfile_img {
    width: 120px;
    height: 120px;
    border-radius: 50%;
    position: relative;
    overflow: hidden;
    border: 2px solid #4645e7;
    margin: 0 auto;
    margin-top: 5px;
    background-size: cover;
    /* background-position: center top; */
}
</style>
